import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { BankTransferContext } from "../../context/BankTransfer";
import classNames from 'classnames/bind';
import styles from './Sidebar.module.css';
import { Method, MethodKeyType } from '../Method';
import { useContext } from 'react';

import { StatusContext } from '../../context/Status';
import { RoutingContext } from '../../context/Router';
import { acceptedWalletsByCountry } from '../../context/utils';
import { ErrorAlertContext } from "../../context/ErrorAlert";

const cx = classNames.bind(styles);

export const Sidebar = () => {
    const [currencyMethods, setCurrencyMethods] = useState<MethodKeyType[]>([
        'card',
    ]);

    const { onShowAlert } =
        useContext(ErrorAlertContext);
    const { currency, payData, merchantKey } = useContext(RoutingContext);
    const location = useLocation();
    const currentPath = location.pathname;

    


    const { pageTransactionStatus } = useContext(StatusContext);
    const {
        setTransferDetails,
        setTransferDetailsLoading,
        setTransactionRef,
    } = useContext(BankTransferContext);


    useEffect(() => {
        const methods = acceptedWalletsByCountry(payData?.details?.currency, payData.kit);
        setCurrencyMethods(methods);
    }, [currency, payData.kit]);


    function handleRedirection(responseData: any) {
        if (responseData && responseData.data && responseData.data.auth_url) {
            window.location.replace(responseData.data.auth_url);
        } 
    }

    useEffect(() => {
        if (((currentPath === "/transfer"))) {
            const getTransferDetails = async () => {
                setTransferDetailsLoading(true);
                try {
                    const payload = {
                        ...payData.kit,
                        paymentType: payData.kit?.paymentType || 'html-checkout',
                        productType: payData.kit.productType ?? "COLLECTION"

                    };
                    const response = await axios(
                        `${process.env.REACT_APP_API_URL}pay/${currency ? currency : "NGN"}/banktransfer`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                "x-auth-token": merchantKey,
                                ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                                    "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
                                })
                            },
                            data: payload,
                        }
                    );
                    const responseData = response.data;
                   
                    if (responseData) {
                        if (responseData.data && responseData.data.auth_url) {
                            handleRedirection(responseData)
                        }
                    
                        if (responseData.status === "error") {
                            const errorMessage = responseData.message === "amount should be between 0 and 25,000,000"
                                ? "Amount should be between 1 and 25,000,000"
                                : responseData.message;
                            onShowAlert(responseData, errorMessage);
                            return; 
                        }
                    
                        if (responseData.status === "success") {
                            const { authorization } = responseData.meta || {};
                            if (authorization) {
                                setTransferDetails(authorization);
                            }
                            setTransactionRef(responseData.tx_ref);
                        }
                    } else {
                        console.error("Response data is missing or invalid.");
                    }
                    


                } catch (err) {
                    // @ts-ignore
                    onShowAlert(err, err.error);
                }
                setTransferDetailsLoading(false);
            };
            getTransferDetails();
        }
    }, [currency, merchantKey,  payData.kit,  currentPath]);



    return (
        <div
            className={cx({
                container: true,
                hide: ['success', 'error', 'pin', 'otp', 'codesent'].includes(
                    pageTransactionStatus
                ),
            })}
        >
            <div className={styles.main}>
                <div className={styles.head}>
                    <p className={styles.header}>Pay with</p>
                </div>
                <div className={styles.body}>
                    {currencyMethods.map((method) => (
                        <Method
                            key={method}
                            methodKey={method}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};